import type { AnalyticsObject, AnalyticsProperties } from '../types'

export class ProviderLink implements AnalyticsObject {
  name: string
  properties: ProviderProperties
  constructor(properties: ProviderProperties) {
    this.name = 'Provider Link'
    this.properties = properties
  }
}

export interface ProviderProperties extends AnalyticsProperties {
  provider: {
    slug: string
    widget: ProviderWidgetProperties
    link: ProviderLinkProperties
  }
}

export interface ProviderWidgetProperties {
  type: string
  title?: string
}

export interface ProviderLinkProperties {
  type: 'image' | 'text' | 'button'
  label: string
}
